<template>
  <section>
    <ul class="voucher-list">
      <!--          추천 클래스: recommend-->
      <li v-for="(partnerVoucher, index) in partnerVoucherList" :key="'partner_voucher_' + index">
        <div>
          <div class="label-area">
            <h3>
              <span>{{ getValueFn(partnerVoucher, 'product_name') }}</span>
              <!--                <span class="icon">이용중</span> &lt;!&ndash; 조건 처리&ndash;&gt;-->
              <span class="icon icon-supplant" v-if="isDiscountRate(partnerVoucher)">{{ getValueFn(partnerVoucher, 'discount_rate') }}%</span>
            </h3>
            <div class="price-area">
              <span class="before-price" v-if="getValueFn(partnerVoucher, 'displayamount') !== ''">&#65510;{{ setNumberCommasFn(getValueFn(partnerVoucher, 'displayamount')) }}</span>
              <button type="button" @click="voucherPurchase(partnerVoucher)"
                      :class="getValueFn(selectedVoucher, 'product_name') === getValueFn(partnerVoucher, 'product_name') ? 'btn selected' : 'btn'">
                &#65510;{{ setNumberCommasFn(getValueFn(partnerVoucher, 'amount')) }}
              </button>
            </div>
          </div>
          <table class="benefit-table">
            <caption>웨이브 이용권 표</caption>
            <colgroup>
              <col style="width: 80px;">
              <col>
            </colgroup>
            <tbody>
              <tr>
                <th scope="row">동시시청</th>
                <td>{{ getValueFn(partnerVoucher, 'concurrency') }}</td>
              </tr>
              <tr>
                <th scope="row">화질</th>
                <td>{{ getValueFn(partnerVoucher, 'quality') }}</td>
              </tr>
              <tr>
                <th scope="row">이용기기</th>
                <td>{{ getValueFn(partnerVoucher, 'support_device') }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </li>
    </ul>

    <div class="common-benefit">
      <h4>이용권 공통 혜택</h4>
      <ul class="common-benefit-list">
        <li>
          <span>VOD 30만편 이상(방송/해외시리즈/키즈/애니메이션 등)제공</span>
        </li>
        <li>
          <span>LIVE 100개 이상 채널 시청</span>
        </li>
        <li>
          <span>영화 6천편 무제한 시청(영화플러스 개별구매 별도)</span>
        </li>
        <li>
          <span>다운로드 무제한 (PC 30회 제한) &amp; QVOD / 타임머신 이용 </span>
        </li>
      </ul>
    </div>
  </section>
</template>
<script>
import _ from 'lodash'

export default {
  name: 'PartnerVoucherList',
  props: {
    voucherPurchaseFn: {
      type: Function
    },
    partnerVoucherList: {
      type: Array
    },
    getValueFn: {
      type: Function
    },
    setNumberCommasFn: {
      type: Function
    }
  },
  data () {
    return {
      selectedVoucher: {}
    }
  },
  methods: {
    isDiscountRate (voucherInfo) {
      return _.get(voucherInfo, 'concurrency.0.discount_rate', '') !== ''
    },
    voucherPurchase (voucher) {
      this.selectedVoucher = voucher
      this.voucherPurchaseFn(voucher)
    }
  }
}
</script>
<style lang="scss" src="@/assets/scss/category/ticket.scss"></style>
